import React from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import classNames from 'classnames';
import { TrackingConstant } from 'client/tracking/constant';

import './toggle-button.scss';

/**
 * The component is used with the Features Modal.
 */
export function ToggleButton({ value, name, className = '', isOpen, onClick, isMobile = false }) {
  return (
    <Button
      data-tracking-id="vdp_view_content"
      data-subaction-name={TrackingConstant.VIEW_FEATURES}
      data-tracking-value={value}
      name={name}
      onClick={onClick}
      size="responsive"
      className={classNames('toggle-button-feature w-100 text-capitalize border-0 p-0_5', className, {
        'bg-primary-darker text-white': isOpen,
        'bg-cool-gray-100 text-cool-gray-10': !isOpen,
        'size-16': !isMobile,
        medium: isMobile,
      })}
      id={`tab-${name}`}
      role="tab"
      aria-selected={isOpen}
      aria-controls={`${name}-modal`}
    >
      {name}
    </Button>
  );
}

ToggleButton.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  className: PropTypes.string,
};
